(function(){
  $(function() {
    $(".js-accordionCont").hide();
    $(".js-accordionTrigger").on("click", function(){
      const data = $(this).attr("data-accordion");
      const cont = $('.js-accordionCont[data-accordion="' + data + '"]');
      cont.slideToggle();
      $(this).toggleClass("is-open");
      cont.toggleClass("is-open");
    });
  });
})();
